"use client";
import { j as a } from "./jsx-runtime-CJ-St4mQ.mjs";
import { u as F, a as I, b } from "./NavigationMenu.style-Dq96CLFG.mjs";
import { NavigationMenuContentProvider as k } from "./NavigationMenuLink.js";
import * as s from "react";
import * as w from "react-dom";
import { i as O } from "./inertValue-CseOXFGF.mjs";
import { u as V } from "./NavigationMenuItemContext-CXLOapAH.mjs";
import { u as H, a as B } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { t as _ } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { C as $ } from "./CompositeRoot-DqjHHBWD.mjs";
import { p as q } from "./popupStateMapping-Cl0RMVD6.mjs";
import { F as z } from "./FloatingTree-vWe5pGqE.mjs";
import { c as A } from "./element-DE7VsBMX.mjs";
const G = {
  ...q,
  ..._,
  activationDirection(e) {
    return e ? {
      "data-activation-direction": e
    } : null;
  }
}, v = /* @__PURE__ */ s.forwardRef(function(r, o) {
  const {
    className: i,
    render: u,
    ...N
  } = r, {
    mounted: M,
    viewportElement: R,
    value: x,
    activationDirection: l,
    currentContentRef: p,
    viewportTargetElement: S
  } = F(), h = V(), j = I(), t = M && x === h, m = s.useRef(null), [E, f] = s.useState(!1), {
    mounted: d,
    setMounted: P,
    transitionStatus: C
  } = H(t);
  B({
    ref: m,
    open: t,
    onComplete() {
      t || P(!1);
    }
  });
  const y = s.useMemo(() => ({
    open: t,
    transitionStatus: C,
    activationDirection: l
  }), [t, C, l]), D = s.useCallback((n) => {
    n && (p.current = n);
  }, [p]), g = {
    onFocus() {
      f(!0);
    },
    onBlur(n) {
      A(n.currentTarget, n.relatedTarget) || f(!1);
    }
  }, T = !t && d ? {
    style: {
      position: "absolute",
      top: 0,
      left: 0
    },
    inert: O(!E),
    ...g
  } : g, c = S || R;
  return !c || !(c !== null && d) ? null : /* @__PURE__ */ w.createPortal(/* @__PURE__ */ a.jsx(z, {
    id: j,
    children: /* @__PURE__ */ a.jsx($, {
      render: u,
      className: i,
      state: y,
      refs: [o, m, D],
      props: [T, N],
      customStyleHookMapping: G,
      stopEventPropagation: !0
    })
  }), c);
});
process.env.NODE_ENV !== "production" && (v.displayName = "NavigationMenuContent");
const nt = (e) => {
  const { children: r, className: o, ...i } = e, u = typeof o == "function" ? o({
    open: !1,
    transitionStatus: "idle",
    activationDirection: null
  }) : o;
  return /* @__PURE__ */ a.jsx(
    v,
    {
      className: b({ className: u }),
      ...i,
      children: /* @__PURE__ */ a.jsx(k, { value: !0, children: r })
    }
  );
};
export {
  nt as default
};
